import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import { router } from '@/router'
import { store } from '@/store'
import dayjs from 'dayjs'
// @ts-ignore
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import 'virtual:windi.css'
import Vue from 'vue'
// @ts-ignore
import JsonExcel from 'vue-json-excel'

Vue.config.productionTip = false

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'fa'
})

Vue.component('downloadExcel', JsonExcel)

Vue.filter('formatDate', (date: Date, targetFormat = 'DD/MM/YYYY HH:mm:ss') => dayjs(date).format(targetFormat))

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
